import { render, staticRenderFns } from "./WapShare.vue?vue&type=template&id=22e78e48&scoped=true&"
import script from "./WapShare.vue?vue&type=script&lang=js&"
export * from "./WapShare.vue?vue&type=script&lang=js&"
import style0 from "./WapShare.vue?vue&type=style&index=0&id=22e78e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e78e48",
  null
  
)

export default component.exports